export const terminalSort = (
  terminal,
  list,
  type,
  content,
  sundaywork,
  worknow,
  selfserve,
) => {
  let result = list
  const term = terminal

  if (terminal.length) {
    result =
      list.filter((t) => {
        if (+term.split('№').pop().trim() == t.number) {
          return t
        }
      }) || []
  }

  if (type.length) {
    const сtype = content.types.find((t) => t.title == type)
    if (сtype.type != 'all') {
      result =
        result.filter((d) => {
          const t = d.type
            .split(' ')[0]
            .slice(0, d.type.split(' ')[0].length - 1)
          if (type.includes(t)) {
            return d
          }
        }) || []
    }
  }

  if (sundaywork) {
    result =
      result.filter((t) => {
        const shedule = Object.entries(t.Schedule).find((d) => d[0] == 'Sunday')

        if (shedule && shedule[1].includes('-') && shedule[1].length > 1) {
          return t
        }
      }) || []
  }

  if (selfserve) {
    result =
      result.filter((t) => {
        const shedule = Object.entries(t.services).find(
          (d) => d[1].selfServiceWorkplacesCount == '1',
        )
        if (shedule) {
          return t
        }
      }) || []
  }

  if (worknow) {
    result =
      result.filter((t) => {
        if (t.WarehouseStatus == 'Working') {
          return t
        }
      }) || []
  }

  return result
}
